<div class="row my-3 mx-0">
  <div class="card w-100 mx-3" style="width: fit-content">
    <div class="row mx-0">
      <div class="col-lg-2 col-md-3 col-4 my-auto px-1">
        <img
          src="../../../assets/bags.jpg"
          height="100%"
          width="100%"
          class="border"
        />
      </div>
      <div class="col-md-5 col-lg-5 col-8 ml-0 t-media-12">
        <div class="card-body mx-0 px-0 text-left">
          <span *ngIf="appService.lang == 'en'">Lorem, ipsum.</span>
          <span *ngIf="appService.lang == 'ar'">عنوان عشوائي</span>
          <br />

          <small>4/4/2020 - 10:10:10 am</small>
          <br />
          <small>
            <span
              class="text-success t-media-12"
              *ngIf="appService.lang == 'en'"
              >Lorem ipsum dolor sit amet.</span
            >
            <span
              class="text-success t-media-12"
              *ngIf="appService.lang == 'ar'"
              >وصف للمتجر عشوائي</span
            >
          </small>
        </div>
      </div>
      <div
        class="col-lg-5 col-md-4 text-md-right text-center my-auto pb-2 pb-md-0 px-0"
      >
        <a
          class="btn btn-outline-secondary small mx-1 t-media-12 arabic-dir"
          (click)="openDialogRateOrder()"
        >
          <small class="text-dark">
            <i class="fa fa-star primary" aria-hidden="true"></i>
            {{ "BAZZAR.RATE_ORDER" | translate }}
          </small></a
        >
        <a
          (click)="openDialogOrderDetails()"
          class="btn btn-outline-secondary mx-1 mt-md-2 mt-lg-0 t-media-12 arabic-dir"
        >
          <small class="text-dark">
            <i class="fa fa-asterisk primary"></i>
            {{ "BAZZAR.ORDER_DETAILS" | translate }}
          </small></a
        >
      </div>
    </div>
  </div>
</div>
